import React from "react";
import { OtpVerification } from "../../../components";

export const OtpVerificationPage = () => {
  return <OtpVerification />;
};
